export const WEEK_LABELS = ['Week 0', 'Week 1', 'Week 2', 'Week 3', 'Week 4', 'Week 5', 'Week 6', 'Week 7', 'Week 8', 'Week 9'] as const;

export const EVALUATOR_TITLE_MAP = {
  'General Manager': { abbr: 'GM', full: 'General Manager' },
  'Restaurant Manager': { abbr: 'RM', full: 'Restaurant Manager' },
  'Assistant Manager': { abbr: 'AM', full: 'Assistant Manager' },
  'Assistant General Manager': { abbr: 'AGM', full: 'Assistant General Manager' },
  'Shift Supervisor': { abbr: 'SS', full: 'Shift Supervisor' },
  'Shift Manager': { abbr: 'SM', full: 'Shift Manager' },
  'GM': { abbr: 'GM', full: 'General Manager' },
  'RM': { abbr: 'RM', full: 'Restaurant Manager' },
  'AM': { abbr: 'AM', full: 'Assistant Manager' },
  'AGM': { abbr: 'AGM', full: 'Assistant General Manager' },
  'SS': { abbr: 'SS', full: 'Shift Supervisor' },
  'SM': { abbr: 'SM', full: 'Shift Manager' },
  'rm': { abbr: 'RM', full: 'Restaurant Manager' },
  // Case variations
  'general manager': { abbr: 'GM', full: 'General Manager' },
  'restaurant manager': { abbr: 'RM', full: 'Restaurant Manager' },
  'assistant manager': { abbr: 'AM', full: 'Assistant Manager' },
  'assistant general manager': { abbr: 'AGM', full: 'Assistant General Manager' },
  'shift supervisor': { abbr: 'SS', full: 'Shift Supervisor' },
  'shift manager': { abbr: 'SM', full: 'Shift Manager' },
  'gm': { abbr: 'GM', full: 'General Manager' },
  'am': { abbr: 'AM', full: 'Assistant Manager' },
  'agm': { abbr: 'AGM', full: 'Assistant General Manager' },
  'ss': { abbr: 'SS', full: 'Shift Supervisor' },
  'sm': { abbr: 'SM', full: 'Shift Manager' },
  // Mixed case variations
  'Gm': { abbr: 'GM', full: 'General Manager' },
  'Rm': { abbr: 'RM', full: 'Restaurant Manager' },
  'Am': { abbr: 'AM', full: 'Assistant Manager' },
  'Agm': { abbr: 'AGM', full: 'Assistant General Manager' },
  'Ss': { abbr: 'SS', full: 'Shift Supervisor' },
  'Sm': { abbr: 'SM', full: 'Shift Manager' }
} as const;

export const API_ENDPOINTS = {
  BOT_STATUS: '/api/bot/trueview/bot/status/last-successful',
  EVALUATION_DATA: '/api/bot/trueview/data',
  EXTENDED_DATA: '/api/bot/trueview/extended/data',
  MARKET_DATA: '/api/bot/trueview/data',
  EMAIL_LOGS: '/api/bot/email-logs'
} as const;

export const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
] as const;